import { BusinessAreaRepository } from "../repositories/BusinessArea.repository";

export const BusinessAreaService = {
    getBusinessArea,
}

async function getBusinessArea(){
    const res = await BusinessAreaRepository.getBusinessArea();
    return res;
}